import React from "react";
import { BorderedButton, GradientBorderBox } from "../../../../Components";
import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SmartGadgetCard from "./SmartGadgetCard";
import NorthWestIcon from "@mui/icons-material/NorthWest";
import { useNavigate } from "react-router-dom";
export default function SmartGadgetsSct({ products }) {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:900px)");
  const navigate = useNavigate();
  const isSmall = useMediaQuery(theme.breakpoints.down("xlg")); // 0–599
  const isMedium = useMediaQuery(theme.breakpoints.between("xlg", "xxl")); // 600–1199
  const isLarge = useMediaQuery(theme.breakpoints.between("xxl", "exl")); // 1200–1499
  const isExtraLarge = useMediaQuery(theme.breakpoints.up("exl")); // 1500+

  // Decide maxItems based on which breakpoint is active
  let maxItems = 1; // default for small
  if (isMedium) maxItems = 2;
  if (isLarge) maxItems = 4;
  if (isExtraLarge) maxItems = 6;

  const items = products?.map((pr, index) => {
    if (index <= maxItems) {
      return <SmartGadgetCard key={index} pr={pr} />;
    }
  });
  return (
    <Container maxWidth={"exl"} sx={{ pt: { xs: "10rem", lg: "0rem" } }}>
      <Stack
        direction={"row"}
        sx={{
          alignItems: "center",
          position: "relative",
          p: "1rem",
          minHeight: { xs: "80px", md: "140px" },
        }}
      >
        {/* content */}
        <Stack
          direction={{ xs: "row", lg: "column" }}
          sx={{
            textAlign: "center",
            position: { xs: "absolute", lg: "static" },
            bottom: "100%",
            left: "50%",
            transform: {
              xs: "translate(-50% , -150%)",
              md: "translate(-50% , -200%)",
              lg: "translate(0% , 0%)",
            },
            width: { xs: "100%", lg: "auto" },
            justifyContent: { xs: "space-between", lg: "start" },
          }}
        >
          <Stack
            sx={{
              width: { xs: "50%", lg: "100%" },
              alignItems: "center",
              transform: { xs: "translateX(-50%)", lg: "translateX(0%)" },
            }}
          >
            <Typography sx={{ fontSize: "1.5rem", fontWeight: "bold" }}>
              گجت های
            </Typography>
            <Typography
              sx={{
                color: theme.palette.primary.main,
                display: "block",
                fontSize: "1.5rem",
                fontWeight: "bold",
              }}
            >
              هوشمند
            </Typography>
          </Stack>
          <Button
            onClick={() => navigate("products/@smart-gadget")}
            sx={{
              fontSize: "inherit",
              fontWeight: "bold",
              borderRadius: "10px",
              color: "white",
              bgcolor: "transparent",
              position: "relative",
              height: "50px",
              width: { xs: "50px", lg: "auto" },
              zIndex: "20",
              mt: ".5rem",
              minWidth: "0",
              ":hover": {
                bgcolor: "rgba(59, 59, 59, 0.2)",
              },
            }}
          >
            {isMobile ? <NorthWestIcon /> : " مشاهده همه"}
            <GradientBorderBox
              inside={true}
              radius={isMobile ? "50%" : "10px"}
            />
          </Button>
        </Stack>

        {items?.length <= 0 ? (
          <Stack
            sx={{
              justifyContent: "center",
              alignItems: "center",
              width: "80%",
              mx: "auto",
            }}
          >
            <Typography>تعداد محصولات کافی نمیباشد !</Typography>
          </Stack>
        ) : (
          <Stack
            direction={"row"}
            sx={{
              gap: "1rem",
              justifyContent: { xs: "center", lg: "space-between" },
              position: "absolute",
              // top:"50%",
              // transform:"translateY(-50%)",
              left: { xs: "50%", lg: "2rem" },
              transform: {
                xs: "translate(-50% , -30%)",
                lg: "translate(0% , 0%)",
              },
            }}
          >
            {items}
          </Stack>
        )}
        <GradientBorderBox />
      </Stack>
    </Container>
  );
}
